import React from "react";
import "./Weather.css";
import { useTestServiceClient } from "../../services/brainflex/TestServiceClient";
import type { Forecast, WeatherOutput } from "../../services/brainflex/TestServiceClient";
import ServiceTransaction from "../../services/ServiceTransaction";

const Weather: React.FC = () => {
  const [forecasts, setForecasts] = React.useState<Forecast[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const testServiceClient = useTestServiceClient();

  const normalizeForecasts = React.useCallback((data: unknown): Forecast[] => {
    if (Array.isArray(data)) return data as Forecast[];

    if (data && typeof data === "object") {
      const nested = (data as { forecasts?: unknown }).forecasts;
      if (Array.isArray(nested)) return nested as Forecast[];
    }

    return [];
  }, []);

  const populateWeatherData = React.useCallback(async () => {
    const transaction: ServiceTransaction<WeatherOutput> = await testServiceClient.getTestWeather();
    if (transaction.response.isSuccess) {
      setForecasts(normalizeForecasts(transaction.response.success?.data));
    } else {
      setForecasts([]);
    }
    setIsLoading(false);
  }, [testServiceClient, normalizeForecasts]);

  React.useEffect(() => {
    populateWeatherData();
  }, [populateWeatherData]);

    const contents = isLoading
      ? <p><em>Loading... Please refresh once the ASP.NET backend has started. See <a href="https://aka.ms/jspsintegrationreact">https://aka.ms/jspsintegrationreact</a> for more details.</em></p>
      : forecasts.length === 0
      ? <p><em>No forecasts were returned by the API.</em></p>
      : <table className="table table-striped" aria-labelledby="tableLabel">
          <thead>
            <tr>
              <th>Date</th>
              <th>Temp. (C)</th>
              <th>Temp. (F)</th>
              <th>Summary</th>
            </tr>
          </thead>
          <tbody>
            {forecasts.map(forecast =>
              <tr key={forecast.date}>
                <td>{forecast.date}</td>
                <td>{forecast.temperatureC}</td>
                <td>{forecast.temperatureF}</td>
                <td>{forecast.summary}</td>
              </tr>
            )}
          </tbody>
      </table>;

  return (
      <div>
          <h1 id="tableLabel">Weather forecast - 17</h1>
          <p>This component NOW fetches data from a server</p>
          {contents}
      </div>
  );
}

export default Weather;